/** Editor used to author a template or campaign body. Mirrors the editorTypeID column. */
export const EditorType = { Designer: 1, Html: 2 } as const;
export type EditorTypeId = typeof EditorType[keyof typeof EditorType];

export type EmailHtmlIssueSeverity = 'error' | 'warning' | 'info';

export interface EmailHtmlIssue {
	severity: EmailHtmlIssueSeverity;
	code: string;
	message: string;
	detail?: string;
}

export interface EmailImageResult {
	original: string;
	hosted?: string;
	error?: string;
}

export interface EmailHtmlImportResult {
	html: string;
	issues: EmailHtmlIssue[];
	images: EmailImageResult[];
}

export type EmailPreviewDevice = 'desktop' | 'mobile';

/** Help for the expert-mode email toolbar's info icon (static HTML, shown with [escape]="false"). */
export const EXPERT_MODE_HELP_HTML =
	'<p><b>Bringing in HTML</b><br>Paste HTML from your design tool, drop an .html file onto the code editor, or use <i>Open file</i>. ' +
	'Every image the email uses is copied to One Morning\'s own storage automatically, and the HTML is updated to point at the copies, ' +
	'so the email keeps working even if the original image is moved or deleted.</p>' +
	'<p><b>Copy images to storage</b><br>Runs that image copy again on whatever is in the editor now. Use it after you add or change an ' +
	'image address by hand. Images already on One Morning storage are left alone.</p>' +
	'<p><b>Upload an image</b><br>For an image file on your computer, which the server can\'t reach on its own ' +
	'(the "Image can\'t be reached" error). Put the cursor where the image should go, or select an existing &lt;img …&gt; tag ' +
	'to replace it, then pick the file. It\'s uploaded to One Morning storage and an image tag pointing at it is inserted there.</p>';

/**
 * True when an Unlayer design (as returned by exportHtml) has at least one content block.
 * A new, untouched design has empty rows, which is why checking for "{}" isn't enough.
 */
export function unlayerDesignHasContent(design: any): boolean {
	return !!design?.body?.rows?.some((row: any) => row?.columns?.some((col: any) => (col?.contents?.length ?? 0) > 0));
}
